export default {"src":"/_next/static/media/situation-family.79f98b0d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};